import { Box, BoxProps, styled } from '@mui/material';
import { ReactElement } from 'react';

const OuterContainer = styled(Box)(() => ({
    position: 'relative',
    '&:after': {
        content: '""',
        display: 'block',
        paddingBottom: '100%',
    },
}));

const InnerContainer = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'absolute',
}));

export const SquareBox = (props: BoxProps): ReactElement => {
    const { children, ...boxProps } = props;
    return (
        <OuterContainer {...boxProps}>
            <InnerContainer>{children}</InnerContainer>
        </OuterContainer>
    );
};
